// extracted by mini-css-extract-plugin
export default {"disabled":"tableBodyUsers_disabled__R6rx-","actionsWrap":"tableBodyUsers_actionsWrap__yAVUm","loginBtn":"tableBodyUsers_loginBtn__zVxLQ"};